module.exports = __webpack_public_path__ + "static/media/home_background.531e958c.jpeg";